export default __webpack_public_path__ + "static/media/montpelier-1.2851c136.jpg";